import React from 'react';

const Table = ({ columns, data, loading = false, emptyMessage = 'No data available', wrapperClassName = '', getRowClassName = () => '' }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={`overflow-x-auto ${wrapperClassName}`}>
      <table className="min-w-full divide-y divide-gray-200 dark:divide-[#1a3884]/30">
        <thead className="bg-gray-50 dark:bg-[#001f40]">
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider"
              >
                {column.header || column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white dark:bg-[#002147] divide-y divide-gray-200 dark:divide-[#1a3884]/30">
          {data.map((row, rowIndex) => (
            <tr 
              key={rowIndex} 
              className={`hover:bg-gray-50 dark:hover:bg-[#001f40] transition-colors ${getRowClassName(row)}`}
            >
              {columns.map((column, colIndex) => (
                <td key={colIndex} className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100 relative">
                  {column.render ? column.render(row) : row[column.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
